$(document).ready(function () {
    $("#form-add-item-pdv").on('submit', function (e) {
        e.preventDefault()
        let data = new FormData(this)
        addItemToOrder(data, "/admin/pdv_add_item")
    })

    function addItemToOrder(data, route) {
        $(".loader_").addClass("loading")
        $.ajax({
            url: route,
            type: "post",
            data: data,
            processData: false,
            contentType: false,
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }, success: function (response) {
                setTimeout(function () {
                    $(".loader_").removeClass("loading")
                    $("#modal_show_book").modal('hide');
                    $(".img-book-pdv").attr("src", "https://www.editorialalmadia.com/images/covers/portada_libro.png");
                    alertSuccess('')
                    document.getElementById('div_view_resumen').innerHTML = response.view_resumen;
                    //showView(response.view_resumen)
                    $("#searchInputBook").val('')
                    //document.getElementById('div_result_books').innerHTML = "";
                }, 1000)

            }, error: function (errors, xhr, status,) {
                $(".loader_").removeClass("loading")
                var indices = errors.responseJSON.errors
                $.each(indices, function (index, value) {

                })
            }
        })
    }

    $(document).on('input', '.item-quantity', function () {
        var quantity = $(this).val();
        var bookId = $(this).data('book');
        var order = $(this).data('order');

        if (quantity > 0) {

            let data = new FormData()
            data.append('bookId', bookId)
            data.append('order', order)
            data.append('quantity', quantity)
            sendDataUpdateQuantity(data, '/admin/pdv_update_order_quantity')
        }

    });


    function sendDataUpdateQuantity(data, route) {
        $.ajax({
            url: route, type: "post", data: data, processData: false, contentType: false, headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }, success: function (response) {
                if (response.type === "error") {
                    console.log("Ocurrio un error");
                } else {
                    setTimeout(function () {
                        showView(response.view_resumen)
                        location.reload();
                    }, 1000)
                }

            }, error: function (errors, xhr, status,) {
                $(".loader_").removeClass("loading")
                var indices = errors.responseJSON.errors
                $.each(indices, function (index, value) {

                })
            }
        })
    }

    function showView(view_resumen) {
        let oldDiv = document.getElementById('div_view_resumen');
        console.log(oldDiv)
        if (oldDiv) {
            if (oldDiv.remove()) {
                console.log("Eliminado")
            }

        }

        let newDiv = document.createElement('div');
        newDiv.id = 'div_view_resumen';
        newDiv.innerHTML = view_resumen;

        var parentContainer = document.getElementById('parent');
        if (parentContainer) {
            parentContainer.appendChild(newDiv);
        } else {
            console.error("Contenedor padre no encontrado");
        }
    }

    window.pdvDeleteItem = function (uuid, book_id) {
        swal.fire({
            title: '¿ Estas seguro ?',
            text: "Este artículo sera eliminado.",
            icon: 'warning',
            showCancelButton: true,
            cancelButtonText: "Cancelar",
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, eliminar!'
        }).then((result) => {
            if (result.isConfirmed) {
                let data = new FormData()
                data.append('book', book_id)
                data.append('uuid', uuid)
                sendData(data, '/admin/pdv_delete_item')
            }

        })
    }


    function sendData(data, route) {
        $(".loader_").addClass("loading")
        $.ajax({
            url: route, type: "post", data: data, processData: false, contentType: false, headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }, success: function (response) {
                setTimeout(function () {

                    $(".loader_").removeClass("loading")

                    if (response.type === "error") {
                        swal.fire({
                            icon: 'error',
                            title: response.msg
                        });
                    } else {
                        swal.fire({
                            text: response.msg,
                            icon: "success",
                            confirmButtonText: 'Ok',
                            customClass: {
                                confirmButton: 'almadia_button'
                            }
                        }).then((result) => {

                            if (result.isConfirmed) {
                                location.reload();
                            }
                        });
                    }

                }, 1000)

            }, error: function (errors, xhr, status,) {
                $(".loader_").removeClass("loading")
                var indices = errors.responseJSON.errors
                $.each(indices, function (index, value) {
                    $(".item-" + index).addClass('is-invalid')
                    $(".item-error-" + index).text(value)
                });
            }
        })
    }

    $('input[name="payment"]').on('change', function () {
        let paymentMethod = $('input[name="payment"]:checked').val();
        if (paymentMethod === "Efectivo") {
            $(".div_efectivo").show()
        } else {
            $(".msg_cash_").removeClass('msg_error_cash')
            $(".msg_cash_").removeClass('msg_success_cash')
            $(".msg_cash_").html('')
            $(".cash").val('')
            $(".div_efectivo").hide()
        }
    });


    window.btnDiscount = function (uuid) {
        let data = new FormData()
        let discount = $(".item-discount").val()
        data.append('discount', discount)
        data.append('uuid', uuid)
        if (discount > 0) {
            updateTotal(data, '/admin/pdv_add-additional-discount')
        } else {
            swal.fire({
                icon: 'error',
                title: 'El valor ingresado debe ser superior a 0',
            });
        }
    }

    function updateTotal(data, route) {
        $(".loader_").addClass("loading")
        $.ajax({
            url: route, type: "post", data: data, processData: false, contentType: false, headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }, success: function (response) {

                setTimeout(function () {
                    $(".loader_").removeClass("loading")
                    document.getElementById('div_view_resumen').innerHTML = response.view_resumen;
                    if (response.type === "error") {
                        Swal.fire({
                            icon: 'error',
                            title: response.msg
                        });
                    }
                }, 1000)

            }, error: function (errors, xhr, status,) {
                $(".loader_").removeClass("loading")
                var indices = errors.responseJSON.errors
                $.each(indices, function (index, value) {
                    $(".item-" + index).addClass('is-invalid')
                    $(".item-error-" + index).text(value)
                });
            }
        })
    }


    $("#form-pdv").on('submit', function (e) {
        e.preventDefault();
        let data = new FormData(this)
        let paymentMethod = $('input[name="payment"]:checked').val();
        let valuePaymentCash = $('.cash').val();

        let validaCashPaymentResult = validaCashPayment(paymentMethod, valuePaymentCash)
        if (!validaCashPaymentResult) {
            alertError("Método de pago efectivo: No puede ser menor o igual a cero")
            return;
        }
        createOrder(data, "/admin/pdv_create_order")
    });


    function validaCashPayment(paymentMethod, valuePaymentCash) {
        if (paymentMethod === "Efectivo") {
            if (valuePaymentCash <= 0) {
                return false
            }
            return true
        }
        return true
    }

    function createOrder(data, route) {
        $(".loader_").addClass("loading")
        $.ajax({
            url: route, type: "post", data: data, processData: false, contentType: false, headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }, success: function (response) {
                
                setTimeout(function () {
                    $(".loader_").removeClass("loading")
                    if (response.type === 'error') {
                        swal.fire({
                            icon: 'error',
                            title: 'Ocurrió un error',
                            html: response.msg
                        });
                    } else {
                        swal.fire({
                            text: response.msg,
                            icon: "success",
                            confirmButtonText: 'Ok',
                            customClass: {
                                confirmButton: 'almadia_button'
                            }
                        }).then((result) => {
                            if (result.isConfirmed) {
                                location.reload();
                            }
                        });

                    }
                }, 1000)


            }, error: function (errors, xhr, status,) {
                $(".loader_").removeClass("loading")
                var errorMessages = '';
                var indices = errors.responseJSON.errors;
                $.each(indices, function (index, value) {
                    errorMessages += value[0] + '<br>';
                });
                swal.fire({
                    icon: 'error',
                    title: 'Error de validación',
                    html: errorMessages
                });
            }
        })
    }

    window.clearForm = function ($uuid) {

        swal.fire({
            title: '¿ Estas seguro ?',
            text: "Se eliminaran los items guardados.",
            icon: 'warning',
            showCancelButton: true,
            cancelButtonText: "Cancelar",
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, limpiar!'
        }).then((result) => {
            if (result.isConfirmed) {
                let data = new FormData()
                data.append('uuid', $uuid)
                $.ajax({
                    url: "/admin/pdv_clear-form",
                    type: "post",
                    data: data,
                    processData: false,
                    contentType: false,
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                    },
                    success: function (response) {

                        swal.fire({
                            text: response.msg,
                            icon: "success",
                            confirmButtonText: 'Ok',
                            customClass: {
                                confirmButton: 'almadia_button'
                            }
                        }).then((result) => {
                            if (result.isConfirmed) {
                                location.reload();
                            }
                        });

                    },
                    error: function (errors, xhr, status,) {
                        $(".loader_").removeClass("loading")
                        var indices = errors.responseJSON.errors
                        $.each(indices, function (index, value) {
                            $(".item-" + index).addClass('is-invalid')
                            $(".item-error-" + index).text(value)
                        });
                    }
                })
            }
        })
    }

    $('input.cash').on('blur touchend', function () {
        let total = $(".total_value").val();
        let cash = $(".cash").val()
        if (cash !== "") {

            if (cash > 0) {
                let result = cash - total;
                if (cash < total) {

                    $(".msg_cash_").removeClass('msg_success_cash')
                    $(".msg_cash_").html('El valor ingresado debe ser mayor que el total de la compra.').addClass('msg_error_cash')
                } else {
                    $(".msg_cash_").removeClass('msg_error_cash')
                    $(".msg_cash_").html("Cambio: € " + result.toFixed(2)).addClass('msg_success_cash');
                }
            } else {
                $(".msg_cash_").removeClass('msg_error_cash')
                $(".msg_cash_").removeClass('msg_success_cash')
                $(".msg_cash_").html('')
            }

        }
    });
})
